const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 8,
    boxShadow: "none!important"
  }),
  tableheader: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "center"
  },
  tableheaderlast: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "center"
  },
  tablecontent: {
    color: "black",
    fontSize: "12pt",
    textAlign: "center"
  },
  tablecontent_first: {
    width: "320px",
    color: "black",
    fontSize: "12pt",
    textAlign: "left"
  },
  tablecontentlast: {
    //fontWeight: "bold",
    color: "black",
    fontSize: "12pt"
  },
  failState: {
    color: theme.palette.fail
  },
  passState: {
    color: theme.palette.success
  },
  delayText: {
    color: "black",
    fontSize: "12pt",
    width: "max-content"
  },
  div_table: {
    maxHeight: "560px",
    overflow: "scroll"
  },
  div_table1: {
    paddingTop: 30
  },
  div_table2: {
    height: 300,
    overflow: "auto"
  },
  defaultText: {
    fontSize: "14px",
    width: "100%"
  },
  tableheader_first: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "left",
    width: "320px"
  },
  passedText: {
    color: "#4CAF50",
    fontSize: "14px"
  },
  failedText: {
    color: "#FF5252",
    fontSize: "14px"
  },
  totalGrid: {
    borderRight: "0.5px solid #D3D3D3",
    textAlign: "center",
    paddingTop: "55px !important"
  },
  totalGrid2: {
    borderRight: "0.5px solid #D3D3D3",
    textAlign: "center"
  },
  totalGridLast: {
    textAlign: "center",
    paddingTop: "55px !important"
  },
  infoHead: {
    display: "flex",
    margin: "0 Auto",
    width: "80px"
  },
  pass: {
    margin: theme.spacing.unit,
    textAlign: "center"
  },
  table2: {
    overflow: "auto",
    height: 380
  },
  logo: {
    width: "auto",
    height: "50px",
    maxHeight: "50px",
    backgroundColor: "grey",
    border: "1px solid white",
    display: "inline-block",
    maxWidth: "300px"
  },
  polarity: {
    fontSize: "14px",
    paddingTop: "35px"
  },
  statusText: {
    paddingLeft: "10px"
  },
  parentGrid: {
    justifyContent: "space-evenly"
    //flexWrap: "inherit !important"
  },
  tabGrid: {
    justifyContent: "center",
    paddingBottom: "30px"
  },
  bargraph: {
    paddingBottom: "50px"
  },
  tab: {
    width: "300px !important"
  },
  tableRow1: {
    background: "red !important"
  },
  infoText: {
    paddingTop: "2px",
    paddingLeft: "3px",
    whiteSpace: "nowrap"
  },
  gauge: {
    height: "100px",
    width: "170px",
    paddingLeft: "2%"
  },
  table_first_col: {
    textAlign: "left !important"
  },
  table_last_col: {
    textAlign: "right !important"
  },
  events: {
    lineHeight: "initial !important",
    textAlign: "right !important",
    paddingRight: "20px !important"
  },
  tableRow: {
    "&$selected, &$selected:hover": {
      backgroundColor: "purple"
    }
  },
  hover: {},
  selected: {}
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/results/views/uptime/styles.js